<div class="table-title">
    <ng-container>
        <span class="sectionTitle" stylePreference [textColor]="textColor">
            {{ sectionTitle }}
        </span>
    </ng-container>
    <mat-icon class="edit-icon" (click)="editSectionTitle()" svgIcon="aumico-pattern-icon-edit-write"></mat-icon>
</div>
<div>
    <div [ngClass]="{ Group: options === undefined ? false : options.displayAssetsAndLiabilitiesInSamePage }">
        <ng-container *ngFor="let sectionTable of sectionData; index as i">
            <div
                [ngClass]="{ subGroup: options === undefined ? false : options.displayAssetsAndLiabilitiesInSamePage }"
            >
                <table
                    style="width: 100%"
                    [ngClass]="{
                        'page-break-after-in-print':
                            reportType === 'balance' && i !== lastSectionIndex && !disableBalanceSheetPageBreak
                    }"
                >
                    <ng-container *ngFor="let row of sectionTable">
                        <ng-container *ngIf="row.rowType === 'EmptyRow'">
                            <tr class="empty-row"></tr>
                        </ng-container>
                        <ng-container *ngIf="row.rowType === 'TableHead'">
                            <thead>
                                <tr
                                    [style.color]="tableHeaderColor"
                                    class="big-row-min-height_plus-border-height black-border-down header"
                                >
                                    <th class="title text-align-bottom">
                                        {{ row.t }}
                                    </th>
                                    <th class="notes text-align-bottom" *ngIf="showNotes">{{ row.r }}</th>
                                    <th
                                        class="value text-align-bottom"
                                        [attr.colspan]="1"
                                        [style.background-color]="backgroundColor"
                                    >
                                        {{ row.cV }}
                                    </th>
                                    <th
                                        class="value text-align-bottom"
                                        *ngIf="isFxFormat"
                                        [style.background-color]="backgroundColor"
                                    >
                                        {{ row.cV2 }}
                                    </th>
                                    <th
                                        class="ratios text-align-bottom"
                                        *ngIf="showRatios"
                                        [style.background-color]="backgroundColor"
                                    >
                                        {{ row.cP }}
                                    </th>
                                    <th
                                        class="value text-align-bottom"
                                        *ngIf="!noPreviousData"
                                        [style.background-color]="backgroundColorPY"
                                    >
                                        {{ row.pV }}
                                    </th>
                                    <th
                                        class="value text-align-bottom"
                                        *ngIf="!noPreviousData && isFxFormat"
                                        [style.background-color]="backgroundColorPY"
                                    >
                                        {{ row.pV2 }}
                                    </th>
                                    <th
                                        class="ratios text-align-bottom"
                                        *ngIf="!noPreviousData && showRatios"
                                        [style.background-color]="backgroundColorPY"
                                    >
                                        {{ row.pP }}
                                    </th>
                                </tr>
                            </thead>
                        </ng-container>
                        <ng-container *ngIf="row.rowType === 'GroupHeader'">
                            <tr
                                [class]="'counter-level-' + row.level"
                                [style.color]="tableHeaderColor"
                                class="row-min-height_plus-border-height big-row-min-height_plus-border-height ng-star-inserted"
                            >
                                <td
                                    class="title row-min-height black-border-down bolder-bigger big-row-min-height text-align-top"
                                >
                                    <div class="text-cell">
                                        <!-- <span [class]="'title-text-' + row.level"></span> -->
                                        <span>
                                            {{ row.t }}
                                        </span>
                                    </div>
                                </td>
                                <td
                                    class="notes black-border-down bolder-bigger big-row-min-height"
                                    *ngIf="showNotes"
                                ></td>

                                <td
                                    class="black-border-down bolder-bigger big-row-min-height value"
                                    [style.background-color]="backgroundColor"
                                ></td>
                                <td
                                    class="black-border-down bolder-bigger big-row-min-height value"
                                    *ngIf="isFxFormat"
                                    [style.background-color]="backgroundColor"
                                ></td>
                                <td
                                    class="ratios black-border-down bolder-bigger big-row-min-height"
                                    *ngIf="showRatios"
                                    [style.background-color]="backgroundColor"
                                ></td>

                                <td
                                    class="value black-border-down bolder-bigger big-row-min-height"
                                    *ngIf="!noPreviousData"
                                    [style.background-color]="backgroundColorPY"
                                ></td>
                                <td
                                    class="value black-border-down bolder-bigger big-row-min-height"
                                    *ngIf="!noPreviousData && isFxFormat"
                                    [style.background-color]="backgroundColorPY"
                                ></td>
                                <td
                                    class="ratios black-border-down bolder-bigger big-row-min-height"
                                    *ngIf="!noPreviousData && showRatios"
                                    [style.background-color]="backgroundColorPY"
                                ></td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="row.rowType === 'HeaderRow'">
                            <tr
                                [class]="'counter-level-' + row.level"
                                [style.color]="tableHeaderColor"
                                class="row-min-height_plus-border-height gray-border-down"
                            >
                                <td class="title text-align-top">
                                    <div class="text-cell bolder-bigger">
                                        <span>{{ row.t }}</span>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container
                            *ngIf="row.rowType === 'Row' || row.rowType === 'SubRow' || row.rowType === 'Acc'"
                        >
                            <tr
                                [ngClass]="row.rowType === 'SubRow' ? 'bullet-level-' + row.level : ''"
                                [class]="'counter-level-' + row.level"
                                [style.color]="textColor"
                                class="row-min-height_plus-border-height gray-border-down"
                            >
                                <td class="title text-align-top">
                                    <div class="text-cell">
                                        <!-- <span
                                        [class]="'title-text-' + (reportType === 'balance' ? 'back-' : '') + row.level"
                                    ></span> -->
                                        <span
                                            [class]="
                                                'title-text-' +
                                                (row.rowType === 'SubRow'
                                                    ? 'subrow'
                                                    : row.rowType === 'Acc'
                                                    ? 'acc'
                                                    : '')
                                            "
                                        ></span>

                                        <span>{{ row.t }}</span>
                                    </div>
                                </td>
                                <td class="notes text-align-top" *ngIf="showNotes">{{ row.r }}</td>
                                <td class="text-align-top value" [style.background-color]="backgroundColor">
                                    {{ row.cV }}
                                </td>
                                <td
                                    class="text-align-top value"
                                    *ngIf="isFxFormat"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV2 }}
                                </td>
                                <td
                                    class="ratios text-align-top"
                                    *ngIf="showRatios"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cP }}
                                </td>
                                <td
                                    class="value text-align-top"
                                    *ngIf="!noPreviousData"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pV }}
                                </td>
                                <td
                                    class="value text-align-top"
                                    *ngIf="!noPreviousData && isFxFormat"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pV2 }}
                                </td>
                                <td
                                    class="ratios text-align-top"
                                    *ngIf="!noPreviousData && showRatios"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pP }}
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="row.rowType === 'Of'">
                            <tr
                                [ngClass]="'bullet-level-' + row.level"
                                [style.color]="textColor"
                                class="row-min-height_plus-border-height gray-border-down"
                            >
                                <td class="title text-align-top">
                                    <div class="text-cell">
                                        <!-- <span
                                        [class]="'title-text-' + (reportType === 'balance' ? 'back-' : '') + +row.level"
                                    ></span> -->
                                        <span class="title-text-of"></span>
                                        <span>
                                            {{ row.t }}
                                        </span>
                                    </div>
                                </td>
                                <td class="notes text-align-top" *ngIf="showNotes">{{ row.r }}</td>

                                <td class="text-align-top value" [style.background-color]="backgroundColor">
                                    {{ row.cV }}
                                </td>
                                <td
                                    class="text-align-top value"
                                    *ngIf="isFxFormat"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV2 }}
                                </td>
                                <td
                                    class="ratios text-align-top"
                                    *ngIf="showRatios"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cP }}
                                </td>
                                <td class="value text-align-top" *ngIf="!noPreviousData" [style.background-color]="backgroundColorPY">{{ row.pV }}</td>
                                <td class="value text-align-top" *ngIf="!noPreviousData && isFxFormat" [style.background-color]="backgroundColorPY">{{ row.pV2 }}</td>
                                <td class="ratios text-align-top" *ngIf="!noPreviousData && showRatios" [style.background-color]="backgroundColorPY">
                                    {{ row.pP }}
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container *ngIf="row.rowType === 'RowTotal'">
                            <tr
                                [ngClass]="'hidden-level-' + row.level"
                                [style.color]="tableFooterColor"
                                class="row-min-height_plus-border-height gray-border-down"
                            >
                                <td class="title text-align-top">
                                    <span>{{ row.t }}</span>
                                </td>
                                <td class="notes text-align-top" *ngIf="showNotes">{{ row.r }}</td>

                                <td class="text-align-top value" [style.background-color]="backgroundColor">
                                    {{ row.cV }}
                                </td>
                                <td
                                    class="text-align-top value"
                                    *ngIf="isFxFormat"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV2 }}
                                </td>

                                <td
                                    class="ratios text-align-top"
                                    *ngIf="showRatios"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cP }}
                                </td>
                                <td class="value text-align-top" *ngIf="!noPreviousData" [style.background-color]="backgroundColorPY">{{ row.pV }}</td>
                                <td class="value text-align-top" *ngIf="!noPreviousData && isFxFormat" [style.background-color]="backgroundColorPY">{{ row.pV2 }}</td>
                                <td class="ratios text-align-top" *ngIf="!noPreviousData && showRatios" [style.background-color]="backgroundColorPY">
                                    {{ row.pP }}
                                </td>
                            </tr>
                        </ng-container>
                        <ng-container
                            *ngIf="
                                row.rowType === 'SubTotal' ||
                                row.rowType === 'GroupTotal' ||
                                row.rowType === 'TableTotal'
                            "
                        >
                            <tr
                                [style.color]="tableFooterColor"
                                [ngClass]="
                                    !showGroupHeaders && row.rowType !== 'SubTotal'
                                        ? 'reset-counter-' + (row.level == undefined ? 1 : row.level)
                                        : ''
                                "
                                class="row-min-height_plus-border-height big-row-min-height_plus-border-height ng-star-inserted"
                            >
                                <td
                                    class="title row-min-height black-border-down bolder-bigger big-row-min-height text-align-top"
                                >
                                    <span> {{ row.t }}</span>
                                </td>
                                <td
                                    class="notes black-border-down bolder-bigger big-row-min-height text-align-top"
                                    *ngIf="showNotes"
                                >
                                    {{ row.r }}
                                </td>

                                <td
                                    class="black-border-down bolder-bigger big-row-min-height text-align-top value"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV }}
                                </td>
                                <td
                                    class="black-border-down bolder-bigger big-row-min-height text-align-top value"
                                    *ngIf="isFxFormat"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cV2 }}
                                </td>
                                <td
                                    class="ratios black-border-down bolder-bigger big-row-min-height text-align-top"
                                    *ngIf="showRatios"
                                    [style.background-color]="backgroundColor"
                                >
                                    {{ row.cP }}
                                </td>

                                <td
                                    class="value black-border-down bolder-bigger big-row-min-height text-align-top"
                                    *ngIf="!noPreviousData"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pV }}
                                </td>
                                <td
                                    class="value black-border-down bolder-bigger big-row-min-height text-align-top"
                                    *ngIf="!noPreviousData && isFxFormat"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pV2 }}
                                </td>
                                <td
                                    class="ratios black-border-down bolder-bigger big-row-min-height text-align-top"
                                    *ngIf="!noPreviousData && showRatios"
                                    [style.background-color]="backgroundColorPY"
                                >
                                    {{ row.pP }}
                                </td>
                            </tr>
                        </ng-container>
                    </ng-container>
                </table>

                <div
                    [ngClass]="{
                        'separator-between-tables': reportType === 'balance' && i !== lastSectionIndex
                    }"
                ></div>
            </div>
        </ng-container>
    </div>
</div>
